import { render, staticRenderFns } from "./form-silabus.vue?vue&type=template&id=45c20457&"
import script from "./form-silabus.vue?vue&type=script&lang=js&"
export * from "./form-silabus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports